(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-ten-jewelry"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cp-ten').forEach(function(article) {
    var hero = article.querySelector('.cp-ten-hero');
    var sticky = article.querySelector('.cp-ten-sticky');
    if (!hero || !sticky) return;
    var closing = article.querySelector('.cp-ten-closing');
    function updateSticky() {
      var heroPassed = hero.getBoundingClientRect().bottom < 0;
      var atFinal = closing && closing.getBoundingClientRect().top < window.innerHeight;
      sticky.classList.toggle('is-visible', heroPassed && !atFinal);
    }
    var observer = new IntersectionObserver(updateSticky);
    observer.observe(hero);
    if (closing) observer.observe(closing);
    var scheduled = false;
    window.addEventListener('scroll', function() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function() {
        updateSticky();
        scheduled = false;
      });
    }, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-trust-bar')) {
    customElements.define('cp-trust-bar', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.list = this.querySelector('[data-list]');
        this.dots = this.querySelector('[data-dots]');
        this.items = Array.from(this.list.children);
        this.index = 0;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.dots.replaceChildren(...this.items.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cp-trust-bar__dot';
          dot.setAttribute('aria-label', `${index + 1} / ${this.items.length}`);
          dot.addEventListener('click', () => this.go(index));
          return dot;
        }));

        this.dots.hidden = this.items.length < 2;
        this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
        this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
        window.addEventListener('resize', () => this.go(this.index, false));
        this.go(0, false);
      }

      getStep() {
        return this.items.length > 1 ? this.items[1].offsetLeft - this.items[0].offsetLeft : 0;
      }

      setOffset(offset, animate) {
        // Same speed and easing as the Maison Vallier slider (Splide: 400ms, cubic-bezier(0.25, 1, 0.5, 1))
        this.list.style.transition = animate ? 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        this.list.style.transform = `translateX(${offset}px)`;
      }

      go(index, animate = true) {
        this.index = Math.max(0, Math.min(index, this.items.length - 1));
        this.setOffset(-this.index * this.getStep(), animate);
        this.updateDots();
      }

      onPointerDown(event) {
        if (!this.mobileQuery.matches || event.button > 0) {
          return;
        }

        this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp, dx: 0, moved: false};
      }

      onPointerMove(event) {
        const drag = this.drag;

        if (!drag || event.pointerId !== drag.id) {
          return;
        }

        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;

        if (!drag.moved) {
          if (Math.abs(dx) < 5) {
            return;
          }

          // A mostly vertical gesture is a page scroll, not a swipe
          if (Math.abs(dy) > Math.abs(dx)) {
            this.drag = null;
            return;
          }

          drag.moved = true;
          this.track.setPointerCapture(drag.id);
        }

        // The card follows the finger, with resistance past the first and last card
        const pastEdge = (this.index === 0 && dx > 0) || (this.index === this.items.length - 1 && dx < 0);
        drag.dx = pastEdge ? dx / 3 : dx;
        this.setOffset(-this.index * this.getStep() + drag.dx, false);
      }

      onPointerUp(event) {
        const drag = this.drag;
        this.drag = null;

        if (!drag || !drag.moved) {
          return;
        }

        // Never more than one card per swipe: a short flick or a drag past 15% of the card moves one
        const speed = Math.abs(drag.dx) / Math.max(1, event.timeStamp - drag.time);
        const moves = Math.abs(drag.dx) > this.getStep() * 0.15 || speed > 0.3;
        this.go(this.index + (moves ? (drag.dx < 0 ? 1 : -1) : 0));
      }

      updateDots() {
        Array.from(this.dots.children).forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.index);
          dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonials"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('testimonials-slider')) {

  customElements.define(

    'testimonials-slider',

    class TestimonialsSlider extends HTMLElement {

      connectedCallback() {

        this.track =
          this.querySelector(
            '[data-track]'
          );


        this.prev =
          this.querySelector(
            '[data-prev]'
          );


        this.next =
          this.querySelector(
            '[data-next]'
          );


        if (!this.track) {
          return;
        }


        this.target =
          null;


        this.lastClick =
          0;


        this.loopEnabled =
          false;


        this.scrollTimer =
          null;


        this.stateFrame =
          null;


        this.initialized =
          false;


        this.mobileQuery =
          window.matchMedia(
            '(max-width: 749px)'
          );


        this.prev?.addEventListener(
          'click',
          () => this.go(-1)
        );


        this.next?.addEventListener(
          'click',
          () => this.go(1)
        );


        this.initDrag();

        this.initInfiniteLoop();
        this.initDots();


        this.track.addEventListener(
          'scroll',
          () => {

            if (
              this.mobileQuery.matches
            ) {

              if (!this.stateFrame) {

                this.stateFrame =
                  requestAnimationFrame(
                    () => {

                      this.updateCardStates();

                      this.stateFrame =
                        null;

                    }
                  );

              }

            }


            if (
              !this.loopEnabled
            ) {
              return;
            }


            clearTimeout(
              this.scrollTimer
            );


            this.scrollTimer =
              setTimeout(
                () => {

                  this.normalizeLoop();

                  this.updateCardStates();

                },
                150
              );

          },
          {
            passive: true
          }
        );


        if (
          'onscrollend' in
          this.track
        ) {

          this.track.addEventListener(
            'scrollend',
            () => {

              this.normalizeLoop();

              this.updateCardStates();

            }
          );

        }


        this.handleMediaChange =
          () => {

            this.initInfiniteLoop();

          };


        if (
          this.mobileQuery
            .addEventListener
        ) {

          this.mobileQuery
            .addEventListener(
              'change',
              this.handleMediaChange
            );

        } else {

          this.mobileQuery
            .addListener(
              this.handleMediaChange
            );

        }


        if (
          'ResizeObserver' in window
        ) {

          this.resizeObserver =
            new ResizeObserver(
              () => {

                if (
                  !this.initialized
                ) {
                  return;
                }


                this.update();

              }
            );


          this.resizeObserver.observe(
            this.track
          );

        }


        this.update();

      }



      disconnectedCallback() {

        clearTimeout(
          this.scrollTimer
        );


        if (
          this.stateFrame
        ) {

          cancelAnimationFrame(
            this.stateFrame
          );

        }


        this.resizeObserver
          ?.disconnect();


        if (
          this.mobileQuery &&
          this.handleMediaChange
        ) {

          if (
            this.mobileQuery
              .removeEventListener
          ) {

            this.mobileQuery
              .removeEventListener(
                'change',
                this.handleMediaChange
              );

          } else {

            this.mobileQuery
              .removeListener(
                this.handleMediaChange
              );

          }

        }

      }



      /* ==========================================
         CARDS
      ========================================== */

      getCards() {

        return Array.from(
          this.track.querySelectorAll(
            ':scope > .t-card'
          )
        );

      }



      getRealCards() {

        return this
          .getCards()
          .filter(
            (card) =>
              !card.dataset.clone
          );

      }



      getGap() {

        const styles =
          getComputedStyle(
            this.track
          );


        return (
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            0
          ) ||
          0
        );

      }



      getStep() {

        const card =
          this.getCards()[0];


        if (!card) {
          return 0;
        }


        return (
          card
            .getBoundingClientRect()
            .width +
          this.getGap()
        );

      }



      getCardTarget(card) {

        if (!card) {
          return 0;
        }


        const target =
          card.offsetLeft -
          (
            this.track.clientWidth -
            card.offsetWidth
          ) / 2;


        const max =
          Math.max(
            0,
            this.track.scrollWidth -
            this.track.clientWidth
          );


        return Math.max(
          0,
          Math.min(
            target,
            max
          )
        );

      }



      getClosestCard(
        cards = this.getCards()
      ) {

        if (!cards.length) {
          return null;
        }


        const viewportCenter =
          this.track.scrollLeft +
          this.track.clientWidth / 2;


        let closest =
          cards[0];


        let smallestDistance =
          Infinity;


        cards.forEach(
          (card) => {

            const cardCenter =
              card.offsetLeft +
              card.offsetWidth / 2;


            const distance =
              Math.abs(
                cardCenter -
                viewportCenter
              );


            if (
              distance <
              smallestDistance
            ) {

              smallestDistance =
                distance;


              closest =
                card;

            }

          }
        );


        return closest;

      }



      updateCardStates() {

        const cards =
          this.getCards();


        cards.forEach(
          (card) => {

            card.classList.remove(
              'is-active',
              'is-neighbor'
            );

          }
        );


        if (
          !this.mobileQuery.matches ||
          !cards.length
        ) {
          return;
        }


        const active =
          this.getClosestCard(
            cards
          );


        if (!active) {
          return;
        }


        const activeIndex =
          cards.indexOf(
            active
          );


        active.classList.add(
          'is-active'
        );


        const previous =
          cards[
            activeIndex - 1
          ];


        const next =
          cards[
            activeIndex + 1
          ];


        if (previous) {

          previous.classList.add(
            'is-neighbor'
          );

        }


        if (next) {

          next.classList.add(
            'is-neighbor'
          );

        }

      }



      /* ==========================================
         CLONES
      ========================================== */

      prepareClone(
        card,
        originalIndex,
        side
      ) {

        card.dataset.clone =
          side;


        card.dataset.originalIndex =
          String(
            originalIndex
          );


        card.setAttribute(
          'aria-hidden',
          'true'
        );


        card.removeAttribute(
          'id'
        );


        Array.from(
          card.attributes
        ).forEach(
          (attribute) => {

            if (
              attribute.name.indexOf(
                'data-shopify'
              ) === 0
            ) {

              card.removeAttribute(
                attribute.name
              );

            }

          }
        );


        card
          .querySelectorAll(
            'a, button, input, select, textarea, [tabindex]'
          )
          .forEach(
            (element) => {

              element.setAttribute(
                'tabindex',
                '-1'
              );


              element.setAttribute(
                'aria-hidden',
                'true'
              );

            }
          );


        return card;

      }



      removeClones() {

        this.track
          .querySelectorAll(
            ':scope > .t-card[data-clone]'
          )
          .forEach(
            (card) => {

              card.remove();

            }
          );


        this.loopEnabled =
          false;

      }



      /* ==========================================
         INFINITE LOOP
      ========================================== */

      initInfiniteLoop() {

        this.initialized =
          false;


        const oldRealCards =
          this.getRealCards();


        const oldCurrent =
          oldRealCards.length
            ? this.getClosestCard(
                oldRealCards
              )
            : null;


        let previousIndex =
          oldCurrent
            ? oldRealCards.indexOf(
                oldCurrent
              )
            : 0;


        if (
          previousIndex < 0
        ) {
          previousIndex = 0;
        }


        this.removeClones();


        const cards =
          this.getRealCards();


        if (
          !this.mobileQuery.matches ||
          cards.length < 2
        ) {

          this.initialized =
            true;


          this.update();


          return;

        }


        const cloneCount =
          Math.min(
            2,
            cards.length
          );


        const beforeCards =
          cards.slice(
            cards.length -
            cloneCount
          );


        beforeCards.forEach(
          (card) => {

            const originalIndex =
              cards.indexOf(
                card
              );


            const clone =
              this.prepareClone(
                card.cloneNode(true),
                originalIndex,
                'before'
              );


            this.track.insertBefore(
              clone,
              cards[0]
            );

          }
        );


        const afterCards =
          cards.slice(
            0,
            cloneCount
          );


        afterCards.forEach(
          (card) => {

            const originalIndex =
              cards.indexOf(
                card
              );


            const clone =
              this.prepareClone(
                card.cloneNode(true),
                originalIndex,
                'after'
              );


            this.track.appendChild(
              clone
            );

          }
        );


        this.loopEnabled =
          true;


        const positionSlider =
          () => {

            const realCards =
              this.getRealCards();


            if (!realCards.length) {
              return;
            }


            const index =
              Math.max(
                0,
                Math.min(
                  previousIndex,
                  realCards.length - 1
                )
              );


            this.jumpToCard(
              realCards[index]
            );


            this.updateCardStates();

          };


        requestAnimationFrame(
          () => {

            requestAnimationFrame(
              () => {

                positionSlider();


                setTimeout(
                  () => {

                    positionSlider();


                    this.initialized =
                      true;


                    this.update();

                  },
                  100
                );

              }
            );

          }
        );

      }



      /* ==========================================
         POSITION
      ========================================== */

      jumpToCard(card) {

        if (!card) {
          return;
        }


        this.target =
          null;


        this.track.scrollTo({

          left:
            this.getCardTarget(
              card
            ),

          behavior:
            'auto'

        });


        this.updateCardStates();

      }



      normalizeLoop() {

        if (
          !this.loopEnabled ||
          this.track.classList.contains(
            'is-dragging'
          )
        ) {
          return;
        }


        const closest =
          this.getClosestCard();


        if (
          !closest ||
          !closest.dataset.clone
        ) {

          this.updateCardStates();

          return;
        }


        const index =
          Number(
            closest.dataset.originalIndex
          );


        if (
          Number.isNaN(
            index
          )
        ) {
          return;
        }


        const realCards =
          this.getRealCards();


        const targetCard =
          realCards[index];


        if (!targetCard) {
          return;
        }


        this.jumpToCard(
          targetCard
        );


        this.updateCardStates();

      }



      /* ==========================================
         ARROWS
      ========================================== */

      go(direction) {

        if (
          this.loopEnabled
        ) {

          let cards =
            this.getCards();


          let current =
            this.getClosestCard(
              cards
            );


          if (!current) {
            return;
          }


          if (
            current.dataset.clone
          ) {

            const originalIndex =
              Number(
                current.dataset.originalIndex
              );


            const real =
              this.getRealCards()[
                originalIndex
              ];


            if (real) {

              this.jumpToCard(
                real
              );


              current =
                real;


              cards =
                this.getCards();

            }

          }


          let index =
            cards.indexOf(
              current
            );


          if (
            index < 0
          ) {
            return;
          }


          index +=
            direction;


          index =
            Math.max(
              0,
              Math.min(
                index,
                cards.length - 1
              )
            );


          const destination =
            cards[index];


          if (!destination) {
            return;
          }


          this.track.scrollTo({

            left:
              this.getCardTarget(
                destination
              ),

            behavior:
              'smooth'

          });


          return;

        }


        const step =
          this.getStep();


        if (!step) {
          return;
        }


        const max =
          this.track.scrollWidth -
          this.track.clientWidth;


        const now =
          Date.now();


        const from =
          this.target !== null &&
          now - this.lastClick < 450
            ? this.target
            : this.track.scrollLeft;


        let target =
          (
            Math.round(
              from / step
            ) +
            direction
          ) *
          step;


        if (
          direction > 0 &&
          from >= max - 2
        ) {

          target =
            0;

        }

        else if (
          direction < 0 &&
          from <= 2
        ) {

          target =
            max;

        }


        target =
          Math.max(
            0,
            Math.min(
              target,
              max
            )
          );


        this.target =
          target;


        this.lastClick =
          now;


        this.track.scrollTo({

          left:
            target,

          behavior:
            'smooth'

        });

      }



      /* ==========================================
         DESKTOP DRAG
      ========================================== */

      initDrag() {

        let startX =
          0;


        let startLeft =
          0;


        let moved =
          false;


        let down =
          false;


        this.track.addEventListener(
          'pointerdown',
          (event) => {

            if (
              event.pointerType !== 'mouse' ||
              event.button !== 0
            ) {
              return;
            }


            down =
              true;


            moved =
              false;


            startX =
              event.clientX;


            startLeft =
              this.track.scrollLeft;

          }
        );


        this.track.addEventListener(
          'pointermove',
          (event) => {

            if (!down) {
              return;
            }


            const dx =
              event.clientX -
              startX;


            if (
              !moved &&
              Math.abs(dx) > 5
            ) {

              moved =
                true;


              this.track.classList.add(
                'is-dragging'
              );


              this.track.setPointerCapture(
                event.pointerId
              );

            }


            if (moved) {

              this.track.scrollLeft =
                startLeft -
                dx;

            }

          }
        );


        const end =
          () => {

            if (!down) {
              return;
            }


            down =
              false;


            if (!moved) {
              return;
            }


            this.track.classList.remove(
              'is-dragging'
            );


            const closest =
              this.getClosestCard();


            if (closest) {

              this.track.scrollTo({

                left:
                  this.getCardTarget(
                    closest
                  ),

                behavior:
                  'smooth'

              });

            }


            clearTimeout(
              this.scrollTimer
            );


            this.scrollTimer =
              setTimeout(
                () => {

                  this.normalizeLoop();

                  this.updateCardStates();

                },
                400
              );

          };


        this.track.addEventListener(
          'pointerup',
          end
        );


        this.track.addEventListener(
          'pointercancel',
          end
        );


        this.track.addEventListener(
          'click',
          (event) => {

            if (moved) {

              event.preventDefault();

              event.stopPropagation();

              moved =
                false;

            }

          },
          true
        );


        this.track.addEventListener(
          'dragstart',
          (event) => {

            event.preventDefault();

          }
        );

      }



      /* ==========================================
         DOTS (like Maison Vallier): one per review on
         phones, one per scroll position on wider screens
      ========================================== */

      initDots() {
        this.dots = this.querySelector('[data-dots]');

        if (!this.dots) {
          return;
        }

        this.dots.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-dot]');

          if (dot) {
            this.goToDot(Number(dot.dataset.dot));
          }
        });

        this.track.addEventListener('scroll', () => {
          if (!this.dotsFrame) {
            this.dotsFrame = requestAnimationFrame(() => {
              this.updateDots();
              this.dotsFrame = null;
            });
          }
        }, {passive: true});

        window.addEventListener('resize', () => this.renderDots());
        this.renderDots();
      }

      getMaxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      getDotCount() {
        if (this.mobileQuery.matches) {
          return this.getRealCards().length;
        }

        const max = this.getMaxScroll();
        const step = this.getStep();

        return max > 0 && step > 0 ? Math.ceil(max / step - 0.01) + 1 : 1;
      }

      renderDots() {
        const count = this.getDotCount();

        if (this.dots.children.length !== count) {
          this.dots.replaceChildren(...Array.from({length: count}, (_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'testimonials__dot';
            dot.dataset.dot = String(index);
            dot.setAttribute('aria-label', `${index + 1} / ${count}`);
            return dot;
          }));
        }

        this.dots.hidden = count < 2;
        this.updateDots();
      }

      getActiveDot() {
        if (this.mobileQuery.matches) {
          const card = this.getClosestCard();

          if (!card) {
            return 0;
          }

          return card.dataset.clone ? Number(card.dataset.originalIndex) : this.getRealCards().indexOf(card);
        }

        if (this.track.scrollLeft >= this.getMaxScroll() - 2) {
          return this.dots.children.length - 1;
        }

        const step = this.getStep();
        return step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
      }

      updateDots() {
        if (!this.dots) {
          return;
        }

        const active = this.getActiveDot();

        Array.from(this.dots.children).forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
          dot.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }

      goToDot(index) {
        if (this.mobileQuery.matches) {
          const card = this.getRealCards()[index];

          if (card) {
            this.track.scrollTo({left: this.getCardTarget(card), behavior: 'smooth'});
          }

          return;
        }

        this.track.scrollTo({left: Math.min(index * this.getStep(), this.getMaxScroll()), behavior: 'smooth'});
      }



      /* ==========================================
         UPDATE
      ========================================== */

      update() {

        const count =
          this.getRealCards().length;


        const arrows =
          this.querySelector(
            '.testimonials__arrows'
          );


        const scrollable =
          count > 1;


        if (arrows) {

          arrows.hidden =
            !scrollable;

        }


        this.prev?.setAttribute(
          'aria-disabled',
          scrollable
            ? 'false'
            : 'true'
        );


        this.next?.setAttribute(
          'aria-disabled',
          scrollable
            ? 'false'
            : 'true'
        );


        this.updateCardStates();

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-favorites"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (customElements.get('video-favorites')) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class VideoFavorites extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vf-track]');
        this.prev = this.querySelector('[data-vf-prev]');
        this.next = this.querySelector('[data-vf-next]');
        this.videos = Array.from(this.querySelectorAll('video[data-src]'));

        this.onScroll = this.updateArrows.bind(this);
        this.track?.addEventListener('scroll', this.onScroll, {passive: true});
        window.addEventListener('resize', this.onScroll);
        this.prev?.addEventListener('click', () => this.scrollByCard(-1));
        this.next?.addEventListener('click', () => this.scrollByCard(1));
        this.updateArrows();

        this.onSoundClick = (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          const button = target.closest('[data-vf-sound]');
          const clickedVideo = target.closest('video.video-favs__media');
          if (!button && !clickedVideo) return;
          const video = clickedVideo || button.closest('.video-favs__item')?.querySelector('video');
          if (!video) return;
          event.preventDefault();
          this.toggleSound(video);
        };
        this.addEventListener('click', this.onSoundClick);
        this.observeVideos();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.observer?.disconnect();
        this.removeEventListener('click', this.onSoundClick);
        this.videos?.forEach((video) => {
          video.muted = true;
          video.pause();
          this.syncSoundButton(video);
        });
      }

      syncSoundButton(video) {
        const button = video.closest('.video-favs__item')?.querySelector('[data-vf-sound]');
        if (!button) return;
        const label = video.muted ? 'Activar sonido' : 'Silenciar';
        button.textContent = label;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-pressed', String(!video.muted));
      }

      toggleSound(video) {
        const enableSound = video.muted;
        document.querySelectorAll('video-favorites video').forEach((other) => {
          if (other === video) return;
          other.muted = true;
          other.closest('video-favorites')?.syncSoundButton(other);
        });
        this.load(video);
        video.muted = !enableSound;
        if (enableSound) video.volume = 1;
        this.syncSoundButton(video);
        const attempt = video.play();
        attempt?.catch(() => {
          video.muted = true;
          this.syncSoundButton(video);
        });
      }

      observeVideos() {
        if (!this.videos.length) return;

        if (!('IntersectionObserver' in window)) {
          this.videos.forEach((video) => this.load(video));
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;

              if (entry.isIntersecting) {
                this.load(video);
                if (!reducedMotion.matches) video.play().catch(() => {});
              } else {
                video.pause();
                video.muted = true;
                this.syncSoundButton(video);
              }
            });
          },
          {rootMargin: '300px 200px', threshold: 0.1}
        );

        this.videos.forEach((video) => this.observer.observe(video));
      }

      load(video) {
        if (video.dataset.cpPoster) {
          video.poster = video.dataset.cpPoster;
          delete video.dataset.cpPoster;
        }
        if (video.dataset.loaded || !video.dataset.src) return;
        video.src = video.dataset.src;
        video.dataset.loaded = 'true';
      }

      scrollByCard(direction) {
        const card = this.track?.querySelector('.video-favs__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth'});
      }

      updateArrows() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.prev) this.prev.hidden = this.track.scrollLeft <= 2;
        if (this.next) this.next.hidden = this.track.scrollLeft >= maxScroll - 2;
      }
    }

    customElements.define('video-favorites', VideoFavorites);
  })();

  } catch(e) { console.error(e); }
})();
})();
